export const METHOD_LIST = 'console/';
export const CLOUD_TYPE_LIST = 'cloud-type/';
export const CONSOLE_TYPE_LIST = 'console-type/';
export const TEMPLATE_LIST = 'templates/';
export const LAB_CONSOLE_ACCESS_TYPE = 'lab-console-access-type/';
export const VM_ACCESS = 'vm-access/';
export const GET_ALL_TEMPLATE_VM = 'template-details';